<template>
  <div class="page-content user">
    <h1 class="page-title">{{ $locale("sideMenu.users.userManagement") }}</h1>

    <!-- Search Area -->
    <el-row class="search-area">
      <el-col :span="20">
        <el-row :gutter="10">
          <el-col :span="8">
            <el-input :placeholder="$locale('form.plsEnterYourName')" v-model="filter.userName">
              <i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </el-col>
          <el-col :span="6">
            <el-select :placeholder="$locale('global.permission')" v-model="filter.permissions">
              <el-option
                v-for="status in permissionOptions"
                :key="status.label"
                :value="status.value"
                :label="status.label"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <el-select :placeholder="$locale('global.state')" v-model="filter.status">
              <el-option
                v-for="status in statusOptions"
                :key="status.label"
                :value="status.value"
                :label="status.label"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <el-button class="egl-btn-yellow" @click="search_fn">{{ $locale("global.search") }}</el-button>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="4" class="ta-r">
        <el-button class="egl-btn-yellow right-align-btn" @click="toDetail('create')">{{ $locale("global.create") }}</el-button>
      </el-col>
    </el-row>

    <el-table :data="userTable" class="egl-table">
      <el-table-column prop="id" label="ID" min-width="300"></el-table-column>
      <el-table-column
        prop="userName"
        :label="$locale('user.createUser')"
        min-width="300"
      ></el-table-column>
      <el-table-column
        prop="roleText"
        :label="$locale('user.role')"
        min-width="200"
      ></el-table-column>
      <el-table-column width="150">
        <template slot="header">{{ $locale('global.state') }}</template>
        <template slot-scope="scope">
          <i class="el-input__icon egl-icon-point" :class="scope.row.status == 'active' ? 'egl-icon-point-green' : 'egl-icon-point-red'"></i>{{ scope.row.status }}
        </template>
      </el-table-column>
      <el-table-column width="160" align="center">
        <template slot="header">{{ $locale('global.control') }}</template>
        <template slot-scope="scope">
          <div class="handle">
            <template v-if="!scope.row.admin">
              <a @click="changeStatus(scope.$index)">{{ $locale("user.accountChangeStates") }}</a>
              <el-divider direction="vertical"></el-divider>
            </template>
            <a @click="toDetail('detail', scope.row.id)"> {{ $locale("global.detail") }}</a>
            <el-divider direction="vertical"></el-divider>
            <a @click="toDetail('edit', scope.row.id)"> {{ $locale("global.edit") }}</a>
            <template v-if="scope.row.admin == false">
              <el-divider direction="vertical"></el-divider>
              <a @click="deleteUser_fn(scope.$index)">{{ $locale("global.delete") }}</a>
            </template>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <CommPagination
      :total="pageCount"
      :pageSize="onSearch.pageSize"
      @current-change="choosePage"
    />
  </div>
</template>

<script>
import { getUserList, deleteUser, updateUserStatus } from "@/helpers/service/api/user.js";
import { getRoleList } from "@/helpers/service/api/common.js";
import { requestAll } from "@/helpers/service/axiosPlugin";
import countDownAlert from "@/utils/countDownAlert";
import CommPagination from "@/components/common/CommPagination";
import "@/assets/style/user.less";

export default {
  name: "user",
  components: {
    CommPagination,
  },
  data() {
    return {
      onSearch: {
        userName: "",
        status: "",
        permissions: "",
        page: 0,
        pageSize: 10,
      },
      filter: {
        userName: "",
        permissions: "",
        status: "",
      },
      pageCount: 0,
      userTable: [],
      allRoles: [],
      permissionOptions: [],
      statusOptions: [
        {
          label: this.$locale("global.active"),
          value: "active",
        },
        {
          label: this.$locale("global.inactive"),
          value: "inactive",
        }
      ],
      loginUserId: "",
    };
  },
  methods: {
    getUserList_fn(isLoading = false) {
      let obj = { ...this.onSearch };
      return getUserList(obj, isLoading);
    },
    userRes_fn(res) {
      if (res.success) {
        let userArr = [];

        res.data.data.map(user => {
          let userStatus = user.status;
          let roleText_arr = [];

          user.roles.map(userRole => {
            for (let i = 0; i < this.allRoles.length; i++) {
              if (userRole == this.allRoles[i].id) {
                roleText_arr.push(this.allRoles[i].name);

                break;
              }
            }
          });

          userArr.push({
            id: user.id,
            userName: user.userName,
            roleText: roleText_arr.toString(),
            email: user.email,
            mobile: user.mobile,
            roles: user.roles,
            status: userStatus,
            brandId: user.brandId,
            cinemas: user.cinemas,
            admin: user.admin,
          });
        });

        this.userTable = userArr;
        // this.pageCount = Math.ceil(res.data.count / 10);
        this.pageCount = res.data.count || 0;
      }
    },
    getRoleList_fn() {
      const params = {
        page: 0,
        pageSize: 9999,
        status: "active",
      };

      return getRoleList(params, false, false);
    },
    roleRes_fn(res) {
      let that = this;
      if (res.success) {
        that.allRoles = [ ...res.data.data ];
      }
    },

    choosePage(page) {
      this.onSearch = {
        ...this.onSearch,
        page: page - 1,
      };

      this.search_fn();
    },
    search_fn() {
      let that = this;
      this.onSearch = {
        ...this.onSearch,
        ...this.filter,
      };
      this.getUserList_fn(true).then(res => {
        that.userRes_fn(res);
      }).catch(() => {});
    },
    toDetail(act = "create", id = "") {
      let path = "";

      path = "/user/" + act;

      if (id != "") {
        path = path + "/" + id;
      }

      this.$router.push({ path: path });
    },
    changeStatus(index) {
      let that = this;
      let newStatus = "";
      let obj = {
        ...this.userTable[index],
      };

      if (obj.status == "active") {
        newStatus = "inactive";
      } else {
        newStatus = "active";
      }

      // obj.status = newStatus;

      updateUserStatus(`id=${obj.id}&status=${newStatus}`).then(res => {
        if (res.success) {
          requestAll([that.getUserList_fn(), that.getRoleList_fn()]).then(res => {
            let [userRes, roleRes] = res;

            that.roleRes_fn(roleRes);
            that.userRes_fn(userRes);
          });
        }
      }).catch(() => {});
    },
    deleteUser_fn(index) {
      const that = this;
      const { userName } = that.userTable[index];
      const userId = that.userTable[index].id;
      const confirmHtml = `<i class="egl-confirm-question">?</i><span class="result-text">${this.$locale("global.delete")} ${userName}</span>`;

      this.$confirm(confirmHtml, "", {
        dangerouslyUseHTMLString: true,
        showClose: false,
        showCancelButton: true,
        cancelButtonClass: "egl-btn-white",
        cancelButtonText: this.$locale("global.cancel"),
        showConfirmButton: true,
        confirmButtonClass: "egl-btn-yellow",
        confirmButtonText: this.$locale("global.delete"),
        customClass: "egl-confirm",
        closeOnClickModal: false,
      }).then(() => {
        // confirm
        deleteUser({ id: userId }).then(res => {
          if (res.success) {
            countDownAlert({
              content: this.$locale("global.deleteSuccessfully"),
              callback: () => {
                this.search_fn();
              }
            });
          }
        });
      });
    },
  },
  mounted() {
    const that = this;

    requestAll([that.getUserList_fn(), that.getRoleList_fn()]).then(res => {
      let [userRes, roleRes] = res;

      that.roleRes_fn(roleRes);
      that.userRes_fn(userRes);
    });
  },
};
</script>
